import { createFileRoute } from "@tanstack/react-router";

import SubuserDetail from "./-components/SubuserDetail";

export const Route = createFileRoute(
  "/_app/_dashboard/subuser/user/$userid/detail"
)({
  component: SubuserDetail,
});
